<template>
  <div class="dialogs userform">
    <div class="dialog-container form-dialog" v-show="form" @mousedown="hide()">
      <div class="dialog-content" @click.stop="form=true" @mousedown.stop="form=true">
        <div class="dialog-close" @click.stop="hide()"></div>
        <h2><div class="start-icon" >Start Challenge <b>{{challenge}}</b></div></h2>
        <p >Enter your player and company name below to begin Challenge {{challenge}}
          <span class="prize-message" v-if="prizeName"> and for a chance to win <span class="prize-name">{{prizeName}}</span></span>!</p>
        <div class="form-scroll">
          <form id="userform" ref="frm" >
            <div class="form-group">
              <input type="text" class="form-control" size="20" ref="name" @keydown="filterKeys($event)" v-model="userData.name" placeholder="Player name" />
            </div>
            <div class="form-group">
              <input type="text" class="form-control" ref="companyName" size="20" @keydown="filterKeys($event)" v-model="userData.companyName" placeholder="Company Name" />
            </div>
            <div class="error-hint" ref="errorhint"><span>{{errorMessage}}</span></div>
          </form>
        </div>
        <div class="bar"></div>
        <div class="form-buttons">
          <button class="action-button" @click="validate()">Play!</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'userform',
  data: function () {
    return {
      form: false,
      errorMessage: '',
      prizeName: null,
      userData: {}
    }
  },
  components: {
  },
  mounted: function () {
    this.form = this.visible
    for (const idx in this.$store.state.userData) {
      this.userData[idx] = this.$store.state.userData[idx]
    }
    fetch('../prize.txt')
      .then(function (response) {
        return response.text()
      })
      .then(prize => {
        prize = prize.trim()
        if (prize.indexOf('<html>') === 0) {
          prize = ''
        }
        if (prize.length > 0) {
          this.prizeName = prize
        } else {
          this.prizeName = null
        }
        this.$refs.name.focus()
      })
  },
  methods: {
    hide: function () {
      this.$emit('hide')
    },
    filterKeys: function (e) {
      if (e.keyCode === 13) {
        this.validate()
      }
      if (/^\W$/.test(e.key) && !/^[ ]$/.test(e.key)) {
        e.preventDefault()
      }
    },
    validate: function () {
      let valid = true
      const hint = this.$refs.errorhint
      hint.style.display = 'none'
      for (const idx in this.$refs) {
        const el = this.$refs[idx]
        if (el && idx in this.userData) {
          el.setAttribute('error', '')
          if (this.userData[idx].trim() === '') {
            this.userData[idx] = ''
            if (valid) {
              hint.style.left = (el.offsetLeft + 20) + 'px'
              hint.style.top = (el.offsetTop + 56) + 'px'
              hint.style.display = 'block'
              this.errorMessage = 'This field is required'
              el.focus()
            }
            valid = false
            el.setAttribute('error', 'true')
          } else {
            if (idx === 'email') {
              const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
              if (!re.test(this.userData[idx])) {
                if (valid) {
                  hint.style.left = (el.offsetLeft + 20) + 'px'
                  hint.style.top = (el.offsetTop + 56) + 'px'
                  hint.style.display = 'block'
                  this.errorMessage = 'Invalid email'
                  el.focus()
                }
                valid = false
                el.setAttribute('error', 'true')
              }
            }
          }
        }
      }
      if (valid) {
        for (const idx in this.$refs) {
          const el = this.$refs[idx]
          if (el) {
            this.$store.state.userData[idx] = this.userData[idx]
          }
        }
        this.$store.state.userData.prize = this.prizeName
        this.$store.state.userData.startTime = (new Date()).toJSON()
        const hist = this.$store.state.userHistory
        let userFound = false
        for (const user in hist) {
          if (
            hist[user].name.toLowerCase() === this.$store.state.userData.name.toLowerCase() &&
            hist[user].companyName.toLowerCase() === this.$store.state.userData.companyName.toLowerCase()
          ) {
            this.$store.state.userData = JSON.parse(JSON.stringify(hist[user]))
            this.userData = JSON.parse(JSON.stringify(hist[user]))
            if (hist[user].finalStates) {
              this.$store.state.scores = JSON.parse(JSON.stringify(hist[user].maxScores))
            }
            if (hist[user].finalStates) {
              this.$store.state.finalStates = JSON.parse(JSON.stringify(hist[user].finalStates))
            }
            if (hist[user].locks) {
              this.$store.state.locks = JSON.parse(JSON.stringify(hist[user].locks))
            }
            userFound = true
            break
          }
        }
        this.$store.dispatch('store')
        this.$emit('hide')
        if (userFound) {
          this.$emit('found', this.challenge)
        } else {
          this.$emit('success', this.challenge)
        }
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    challenge: {
      type: Number,
      default: 1
    }
  },
  watch: {
    visible: function (newValue) {
      this.form = newValue
      for (const idx in this.$refs) {
        const el = this.$refs[idx]
        el.setAttribute('error', '')
      }
      this.$refs.errorhint.style.display = 'none'
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss" >
.userform{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .dialog-content {
    width: 470px !important;
    padding-bottom: 30px !important;
    p{
      text-align: left;
    }
  }
  .bar{
    height: 5px;
    margin: 5px 0 30px 0;
    border-bottom: 1px solid #DCEFFF;
  }
}
form{
  position: relative;
  padding-bottom: 30px;
  .error-hint{
    position: absolute;
    display: inline-block;
    display: none;
    z-index: 1;
    > span{
      border-radius: 3px;
      color: #fff;
      background-color: #C00000;
      padding: 5px;
    }
  }
}
.form-group{
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  justify-content: space-between;
  .form-control{
    height: 50px;
  }
  input{
    border: 2px solid rgba(38, 153, 251, 0.4) !important;
    border-radius: 10px;
    padding: 0px 12px;
    width: 100%;
    display: block;
    &::placeholder{
      font-style: italic;
    }
    &.half-size{
      width: 48%;
      flex: 0 1 48%;
    }
    &:focus{
      border: 2px solid rgba(38, 153, 251, 0.8) !important;
      outline: none;
    }
    &[error='true']{
      border: 2px solid rgba(251, 38, 38, 0.6) !important;
    }
  }
}
.prize-name{
  font-weight: bold;
}
</style>
